import axios from "axios";
import React, { useEffect, useState } from "react";
import NoDataAvailable from "../../.././../../Assets/Images/NoDataAvailable.png";
import ChatHead from "../../../../Pages/ChatHead/ChatHead";

import ChatHeadLock from "../../../../Pages/ChatHeadLock/ChatHeadLock";
import "./ActivitiesBody.css";
import ActivitiesContent from "./Content/ActivitiesContent";
import ActivitiesContent2 from "./Content/ActivitiesContent2";
import ActivitiesContent3 from "./Content/ActivitiesContent3";
import ActivitiesContent4 from "./Content/ActivitiesContent4";
import ActivitiesContent5 from "./Content/ActivitiesContent5";
import Purchase from "./Content/Purchase";
import Souvenir from "./Content/Souvenir";
import ActivitiesContent8 from "./Content/ActivitiesContent8";
import NodataAvailable from "../../../../Common/NodataAvailable";
import ShareModal from "../../../../Video/ShareModal";

const ActivitiesBody = () => {
  const [posts, setPosts] = useState([]);
  const [posts2, setPosts2] = useState([]);
  const [posts3, setPosts3] = useState([]);
  const [posts4, setPosts4] = useState([]);
  const [posts5, setPosts5] = useState([]);
  const [posts6, setPosts6] = useState([]);
  const [posts7, setPosts7] = useState([]);
  const [posts8, setPosts8] = useState([]);

  const [openMessenger, setOpenMessenger] = React.useState(0);

  const [eventLodaer, setEventLodaer] = useState(false);

  const [liveChattLodaer, setLiveChatLodaer] = useState(false);
  const [greetingsLodaer, setGreetingsLodaer] = useState(false);
  const [eachChat, setEachChat] = useState({});
  const [buffer, setBuffer] = useState(true);
  const [activity, setCountActivity] = useState(0);

  useEffect(() => {
    axios.get("api/user/registerMeestup").then((res) => {
      if (res.data.status === 200) {
        setPosts(res.data.events);
        setLiveChatLodaer(true);
      }
    });

    localStorage.getItem("auth_token") &&
      axios.get("api/user/activity_count").then((res) => {
        setBuffer(false);
        if (res.data.status === 200) {
          setCountActivity(res.data.activity);
        }
      });

    axios.get("api/user/registerLivechat").then((res) => {
      if (res.data.status === 200) {
        setPosts2(res.data.events);
        setLiveChatLodaer(true);
      }
    });
    axios.get("api/user/qna_activites").then((res) => {
      if (res.data.status === 200) {
        setPosts4(res.data.events);
        setLiveChatLodaer(true);
      }
    });
    axios.get("api/user/auction_activites").then((res) => {
      if (res.data.status === 200) {
        setPosts5(res.data.events);
        setLiveChatLodaer(true);
      }
    });

    axios.get("api/user/registerLearningSession").then((res) => {
      if (res.data.status === 200) {
        setPosts3(res.data.events);
        setGreetingsLodaer(true);
      }
    });

    axios.get("api/user/check_notification").then((res) => {
      if (res.data.status === 200) {
        setEventLodaer(res.data.greeting_info);
        setGreetingsLodaer(true);
      }
    });

    axios.get("api/user/marketplace/activities").then((res) => {
      if (res.data.status === 200) {
        setPosts6(res.data?.data);
        setGreetingsLodaer(true);
      }
    });

    axios.get("api/user/souvenir/activities/list").then((res) => {
      if (res.data.status === 200) {
        setPosts7(res.data?.userSouvenir);
        setGreetingsLodaer(true);
      }
    });
    axios.get("api/user/registerGreetings").then((res) => {
      // console.log("greetings", res.data?.events)
      if (res.data.status === 200) {
        setPosts8(res.data?.events);
      }
    });
  }, []);

  return (
    <center>
      <div className="row chatBody_qna ">
        <div className="positionMessenger">
          {openMessenger[0] === 1 && (
            <ChatHead
              data={openMessenger[1]}
              openMessenger={openMessenger}
              setOpenMessenger={setOpenMessenger}
            />
          )}

          {openMessenger[0] === 2 && (
            <ChatHeadLock
              chatData={eachChat}
              data={openMessenger[1]}
              openMessenger={openMessenger}
              setOpenMessenger={setOpenMessenger}
            />
          )}
        </div>
      </div>

      <div className="justify-content-center postTab">
        {buffer ? (
          <>
            <center className="mb-5 mt-5">
              <div
                class="spinner-border text-warning"
                role="status"
                style={{ height: 50, width: 50 }}
              >
                <span class="sr-only">Loading...</span>
              </div>
            </center>
          </>
        ) : (
          <>
            {activity !== 0 ? (
              <>
                {posts.length > 0 && (
                  <div className="mb-4">
                    <h2 className="mt-3 text-dark fw-bold activitiesBg p-2 btn w-100 text-center">
                      Meetup Events
                    </h2>

                    <ActivitiesContent
                      eventLodaer={eventLodaer}
                      event={posts}
                    />
                  </div>
                )}

                {posts2.length > 0 && (
                  <div className="mb-4">
                    <h2 className="mt-3 text-dark fw-bold activitiesBg p-2 btn w-100 text-center">
                      LiveChat Events
                    </h2>

                    <ActivitiesContent2
                      loader={liveChattLodaer}
                      event={posts2}
                    />
                  </div>
                )}

                {posts3.length > 0 && (
                  <div className="mb-4">
                    <h2 className="mt-3 text-dark fw-bold activitiesBg p-2 btn w-100 text-center">
                      Learning Session
                    </h2>

                    <ActivitiesContent3
                      loader={liveChattLodaer}
                      event={posts3}
                    />
                  </div>
                )}

                {/* <LearningResult /> */}

                {posts4.length > 0 && (
                  <div className="mb-4">
                    <h2 className="mt-3 text-dark fw-bold activitiesBg p-2 btn w-100 text-center">
                      Question & Answer
                    </h2>
                    <ActivitiesContent4
                      setEachChat={setEachChat}
                      loader={liveChattLodaer}
                      event={posts4}
                      openMessenger={openMessenger}
                      setOpenMessenger={setOpenMessenger}
                    />
                  </div>
                )}

                {posts5.length > 0 && (
                  <div className="mb-4">
                    <h2 className="mt-3 text-dark fw-bold activitiesBg p-2 btn w-100 text-center">
                      Auction
                    </h2>
                    <ActivitiesContent5
                      loader={liveChattLodaer}
                      event={posts5}
                    />
                  </div>
                )}

                {posts6.length > 0 && (
                  <div className="mb-4">
                    <h2 className="mt-3 text-dark fw-bold activitiesBg p-2 btn w-100 text-center">
                      Marketplace
                    </h2>
                    <Purchase loader={liveChattLodaer} event={posts6}/>
                  </div>
                )}

                {posts7.length > 0 && (
                  <div className="mb-4">
                    <h2 className="mt-3 text-dark fw-bold activitiesBg p-2 btn w-100 text-center">
                      Souvenir
                    </h2>
                    <Souvenir />
                  </div>
                )}
                {posts8.length > 0 && (
                  <div className="mb-4">
                    <h2 className="mt-3 text-dark fw-bold activitiesBg p-2 btn w-100 text-center">
                      Greetings
                    </h2>
                    <ActivitiesContent8
                      loader={liveChattLodaer}
                      event={posts8}
                    />
                  </div>
                )}
              </>
            ) : (
              <NodataAvailable />
            )}
          </>
        )}
      </div>
    </center>
  );
};

export default ActivitiesBody;
